require('@fortawesome/fontawesome');
require('@fortawesome/fontawesome-free-solid');
require('@fortawesome/fontawesome-free-regular');
require('./bootstrap');
require('./common/not_double_submit').default();
require('./common/collapse').default();
